class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  this.cartItemKey = parsedState.key;
  this.getSectionsToRender().forEach((section) => {
    const element = document.getElementById(section.id);
    
    if (!element) {
      console.warn(`Cart notification: Element with id "${section.id}" not found`);
      return;
    }
    
    if (!parsedState.sections[section.id]) {
      console.warn(`Cart notification: Section "${section.id}" not in response`);
      return;
    }
    
    element.innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  // Update cart count bubble without replacing the entire icon
  if (parsedState.sections['cart-icon-bubble']) {
    const bubbleHtml = this.getSectionInnerHTML(
      parsedState.sections['cart-icon-bubble'],
      '.cart-count-bubble'
    );
    let bubble = document.querySelector('.cart-count-bubble');
    
    if (bubble) {
      // Bubble exists, just update it
      bubble.innerHTML = bubbleHtml;
    } else {
      // Bubble doesn't exist, create it
      const cartIconLink = document.querySelector('a.header__icon--cart');
      if (cartIconLink) {
        const newBubble = document.createElement('div');
        newBubble.className = 'cart-count-bubble';
        newBubble.innerHTML = bubbleHtml;
        cartIconLink.appendChild(newBubble);
      }
    }
  }

  if (this.header && typeof this.header.reveal === 'function') {
    this.header.reveal();
  }
  
  this.open();
}

getSectionsToRender() {
  return [
    {
      id: 'cart-notification-product',
      selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
    },
    {
      id: 'cart-notification-button',
      selector: '.shopify-section',
    },
    {
      id: 'cart-icon-bubble',
      selector: '.shopify-section',
    },
  ];
}

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
